import BusinessIcon from "@mui/icons-material/Business";
import { Box, Divider, Paper, Typography } from "@mui/material";
import { colors } from "../../../../../ui/colors";

export const normalizeCostOverride = (input) => {
  if (!input) return null;

  // already an object
  if (typeof input === "object") return input;

  // JSON string
  if (typeof input === "string") {
    try {
      const parsed = JSON.parse(input);
      return parsed && typeof parsed === "object" ? parsed : null;
    } catch {
      return null;
    }
  }

  return null;
};

const BasicJob = ({ service }) => {
  const title = service?.typeOfService?.name ?? service?.name ?? "Unnamed Service";

  const costOverride = normalizeCostOverride(service?.costOverride);

  const units = Number(costOverride?.units ?? 0);
  const unitPrice = Number(costOverride?.value ?? costOverride?.price ?? costOverride?.amount ?? 0);
  const currency = costOverride?.currency ?? "USD";

  const total = units * unitPrice;

  const formattedUnitPrice = unitPrice.toLocaleString();
  const formattedTotal = total.toLocaleString();

  const unitLabel = costOverride?.by === "unit" ? "Units" : "Qty";
  return (
    <Paper
      sx={{
        p: 2.5,
        borderRadius: 2,
        border: "1px solid var(--fx-surface-border, #E2E8F0)",
        backgroundColor: "var(--fx-surface-base, #FFFFFF)",
        boxShadow: "0 1px 2px rgba(16, 24, 40, 0.04)",
      }}
      elevation={0}
    >
      <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}>
          <Box
            sx={{
              width: 38,
              height: 38,
              borderRadius: "50%",
              bgcolor: "var(--fx-colors-info-50, #EFF6FF)",
              border: "1px solid #A9D4FF",
              color: "#1688F0",
              display: "grid",
              placeItems: "center",
              flexShrink: 0,
            }}
          >
            <BusinessIcon sx={{ fontSize: 18 }} />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontWeight: 800, fontSize: 16, color: "var(--fx-surface-text, #0F172A)" }}>{title}</Typography>
            <Typography sx={{ fontWeight: 700, fontSize: 12, color: colors.orange.base }}>Service</Typography>
          </Box>
        </Box>

        <Typography sx={{ fontWeight: 800, fontSize: 18, color: colors.orange.base, whiteSpace: "nowrap" }}>${formattedTotal}</Typography>
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(3, minmax(0, 1fr))" }, gap: 2 }}>
        <Box>
          <Typography sx={{ fontSize: 10, fontWeight: 800, color: "text.secondary", textTransform: "uppercase", letterSpacing: "0.06em" }}>
            Unit Price
          </Typography>
          <Typography sx={{ fontSize: 13, fontWeight: 700 }}>
            ${formattedUnitPrice} {currency}
          </Typography>
        </Box>

        <Box>
          <Typography sx={{ fontSize: 10, fontWeight: 800, color: "text.secondary", textTransform: "uppercase", letterSpacing: "0.06em" }}>
            {unitLabel}
          </Typography>
          <Typography sx={{ fontSize: 13, fontWeight: 700 }}>{units}</Typography>
        </Box>

        <Box>
          <Typography sx={{ fontSize: 10, fontWeight: 800, color: "text.secondary", textTransform: "uppercase", letterSpacing: "0.06em" }}>
            Total
          </Typography>
          <Typography sx={{ fontSize: 13, fontWeight: 800, color: colors.orange.base }}>${formattedTotal}</Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default BasicJob;
